function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaypal = function SvgPaypal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 373.51 450"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M318.58 103.5c0 55.74-51.44 121.5-129.27 121.5h-74.97l-3.68 23.22L93.17 360H0L56.05 0H207c50.83 0 90.82 28.33 105.55 67.7a96.9 96.9 0 0 1 6.03 35.8",
    style: {
      fill: "#002991"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.28 207c-10.271 62.408-64.292 108.153-127.54 108h-52.06l-21.67 135H78.34l14.83-90 17.5-111.78 3.67-23.22h74.97c77.73 0 129.27-65.76 129.27-121.5 38.25 19.74 60.55 59.63 53.7 103.5",
    style: {
      fill: "#60cdff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.58 103.5C302.54 95.11 283.09 90 261.92 90h-126.4l-21.18 135h74.97c77.73 0 129.27-65.76 129.27-121.5",
    style: {
      fill: "#008cff"
    }
  }));
};
export default SvgPaypal;